// JsFromRoutes CacheKey 61f5705854681a3fea3f6097abc204ef
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/broker/quote_request/:id'),
  partners: /* #__PURE__ */ definePathHelper('get', '/broker/quote_request/:id/*step'),
}
